const initialState = {
  tenantConfig: {}
};

const TenantConfigReducer = (state = initialState, action) => {
  if (action.type === 'SET_TENANT_CONFIGURATION') {
    return { ...state, tenantConfig: action.payload };
  }

  return state;
};

export default TenantConfigReducer;
